module.exports = __webpack_public_path__ + "img/upload.c940b4bc.svg";